import { render } from "./FilterAtbusinessShipto.vue?vue&type=template&id=253e1666"
import script from "./FilterAtbusinessShipto.vue?vue&type=script&lang=js"
export * from "./FilterAtbusinessShipto.vue?vue&type=script&lang=js"
script.render = render

export default script